import { getActas, getActasCsv, getActasNotificadorCsv } from "../services/actas.service";
import { useFilterActas } from "../store/filterActasStore";
import { useGeneralAppStore } from "../store/generalAppStore";
// import { getActasNotificador, getMotivos, notificar, reportarNoNotificada } from "../services";
// import { useNotificadoresStore } from "../store/notificadoresStore";
// const { setActas, setMotivos } = useNotificadoresStore.getState();
const { setPaginateCfg } = useFilterActas.getState();
const { handlerLoading } = useGeneralAppStore.getState();

export const getActasHandler = async (setActas, params, payload) => {
  // console.log("getActasHandler", payload);
  // return;
  const result = await getActas(params, payload);
  if (result) {
    const { data, ...paginado } = result;
    setActas(data);
    setPaginateCfg({ ...paginado });
    handlerLoading({ loading: false, loadName: "get_actas" });
  } else {
    handlerLoading({ loading: false, loadName: "get_actas" });
  }
};

export const getActasCsvHandler = async (setActasCsv, payload) => {
  // console.log("getActasCsvHandler", payload);
  // return;
  const result = await getActasCsv(payload);
  if (result) {
    setActasCsv(result);
    // setPaginateCfg({ ...paginado });
  }
};

export const getActasCsvNotificadorHandler = async (setActasCsv, payload) => {
  const result = await getActasNotificadorCsv(payload);
  if (result) {
    setActasCsv(result);
    // setPaginateCfg({ ...paginado });
  }
};

// export const getMotivosReporte = async () => {
//   const result = await getMotivos();
//   setMotivos(result);
// };

// export const reportarActa = async (payload) => {
//   let formData = new FormData();
//   formData.append("acta_id", payload.id);
//   formData.append("latitud", payload.ubicacion[0]);
//   formData.append("longitud", payload.ubicacion[1]);
//   formData.append("motivo_id", payload.motivo_id);
//   formData.append("observacion", payload.observacion);

//   if (payload.motivoManual) {
//     formData.append("motivo_manual", payload.motivoManual);
//   }

//  if(payload.archivo){
//   formData.append("file", payload.archivo[0])
//  }

//   const config = {
//     headers: { "content-type": "multipart/form-data" },
//   };

//  formData.append("acta_id", dataSend.id);
//  formData.append("latitud", dataSend.latitud);
//  formData.append("longitud", dataSend.longitud);
//  formData.append("motivo_id", dataSend.motivo_id);
//  formData.append("observacion", dataSend.observacion);

//  if (dataSend.archivo) {
//    formData.append("archivo", dataSend.archivo[0]);
//  }

//   payload.archivo = payload.archivo[0];

// export const onSubmitNoNotificada = async (formActa, setActas, reset, setIsLoading, row, setRow, setIsLoadingModal, location, setLocation, archivo, setShowModalMotivo) => {

//   let formData = new FormData();    //formdata object
//   formData.append('acta_id', row.id);   //append the values with key, value pair
//   formData.append('latitud', location.latitude);
//   formData.append('longitud', location.longitude);
//   formData.append('motivo_id', formActa.motivo);
//   formData.append('observacion', formActa.observacion);
//   formActa.motivoManual && formData.append('motivo_manual', formActa.motivoManual);

//   formData.append('file', archivo);

//   const config = {
//     headers: { 'content-type': 'multipart/form-data' }
//   }

//   const response = await axios().post("no_notificada", formData, config);
//   const { data, error } = response.data;

//   setIsLoadingModal(false);

//   if (data) {
//     toast.success("Información cargada", toastOptions);
//     setRow(null);
//     reset();
//     setShowModalMotivo(false);
//     setLocation(null);

//     setIsLoading(true);
//     const result = await axios().get("/get_actas_notificador");
//     const { data, error } = result.data;

//     setIsLoading(false);

//     if (data) {
//       setActas(data);
//     }

//     if (error) {
//       toast.error(error, toastOptions);
//     }

//     return;
//   }

//   if (error) {
//     toast.error(error, toastOptions);
//     return;
//   }

// };
//   const { actas } = useNotificadoresStore.getState();

//   const result = await reportarNoNotificada(formData, config);
//   if (result) {
//     const newActas = actas.filter((acta) => acta.id != payload.id);
//     setActas(newActas);
//   }
// };

// export const notificarActa = async (payload) => {
//   const { actas } = useNotificadoresStore.getState();
//   const result = await notificar(payload);
//   if (result) {
//     setActas(
//       actas.map((acta) => {
//         if (acta.id == payload.id) {
//           acta.fecha_notificacion = new Date();
//           acta.estado_id = 4;
//         }
//         return acta;
//       })
//     );
//   }
// };
